import React from 'react';
import {
  ChakraProvider,
  theme,
} from '@chakra-ui/react';
import { RegisterRoutes } from './routes'

function App() {
  return (
    <ChakraProvider theme={theme}>
      <RegisterRoutes />
    </ChakraProvider>
  );
}

export default App;
